import { PageLoading } from "@garther/ui/components";
import { useCallback, useEffect, useState } from "react";

import { useAuthStore } from "@/features/auth/auth.store";

interface AppLoadingProps {
  children: React.ReactNode;
}

export function AppLoading({ children }: AppLoadingProps) {
  const { curUser, loggedIn, loading: authLoading, loadProfile } = useAuthStore();
  const [isReady, setIsReady] = useState(false);

  const initialize = useCallback(async () => {
    await new Promise<void>((resolve) => {
      const check = () => (!authLoading ? resolve() : setTimeout(check, 100));
      check();
    });

    if (loggedIn && curUser.fbUser?.uid) {
      await loadProfile();
    }

    setTimeout(() => setIsReady(true), 300);
  }, [authLoading, loggedIn, curUser.fbUser?.uid, loadProfile]);

  useEffect(() => {
    initialize();
  }, [initialize]);

  if (isReady) return <>{children}</>;

  return <PageLoading />;
}
